import * as actions from '../actionTypes'

const initialState = {
  addressUpdate: '',

  renewalPeriod: {
    period: '',
    amount: '',
    extraFees: []
  },

  masterNumber: '',
  plateNumber: '',
  vinSerialNumber: '',

  renewalperiods: [],

  insuranceCompany: '',
  policyNumber: '',
  effectiveDate: '',
  expiryDate: '',

  commercialAquaculture: '',
  fishingVessel: '',

  vehicleType: '',

  permits: [],

  editPlateNumber: '',

  fullName: '',
  emailAddress: '',
  phoneNumber: '',

  editFromConfirmation: false,

}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.ADDRESS_UPDATE: {
      return {
        ...state,
        addressUpdate: action.payload.description,
      }
    }
    case actions.RENEWAL_PERIOD: {
      return {
        ...state,
        renewalPeriod: { amount: action.payload.amount, period: action.payload.period, extraFees: action.payload.extraFees || [] },
      }
    }
    case actions.MASTER_NUMBER: {
      return {
        ...state,
        masterNumber: action.payload.description,
      }
    }
    case actions.PLATE_NUMBER: {
      return {
        ...state,
        plateNumber: action.payload.description,
      }
    }
    case actions.VIN_SERIAL_NUMBER: {
      return {
        ...state,
        vinSerialNumber: action.payload.description,
      }
    }
    case actions.INSURANCE_COMPANY: {
      return {
        ...state,
        insuranceCompany: action.payload.description,
      }
    }
    case actions.POLICY_NUMBER: {
      return {
        ...state,
        policyNumber: action.payload.description,
      }
    }
    case actions.EFFECTIVE_DATE: {
      return {
        ...state,
        effectiveDate: action.payload.description,
      }
    }
    case actions.EXPIRY_DATE: {
      return {
        ...state,
        expiryDate: action.payload.description,
      }
    }
    case actions.VEHICLE_TYPE: {
      return {
        ...state,
        vehicleType: action.payload.description,
      }
    }
    case actions.COMMERCIAL_AQUACULTURE: {
      return {
        ...state,
        commercialAquaculture: action.payload.description,
      }
    }
    case actions.FISHING_VESSEL: {
      return {
        ...state,
        fishingVessel: action.payload.description,
      }
    }
    case actions.FULL_NAME: {
      return {
        ...state,
        fullName: action.payload.description,
      }
    }
    case actions.EMAIL_ADDRESS: {
      return {
        ...state,
        emailAddress: action.payload.description,
      }
    }
    case actions.CONFIRM_EMAIL_ADDRESS: {
      return {
        ...state,
        confirmEmailAddress: action.payload.description,
      }
    }
    case actions.PHONE_NUMBER: {
      return {
        ...state,
        phoneNumber: action.payload.description,
      }
    }
    case actions.EDIT_PLATE_NUMBER: {
      return {
        ...state,
        editPlateNumber: action.payload.plateNumber,
      }
    }
    case actions.ADD_RENEWAL_PERIODS: {
      return {
        ...state,
        renewalperiods: action.payload,
      }
    }
    case actions.ADD_PERMIT: {
      return {
        ...state,
        permits: [...state.permits, action.payload],
      }
    }
    case actions.EDIT_PERMIT: {
      return {
        ...state,
        permits: state.permits.map((permitInfo) => (permitInfo.plateNumber === state.editPlateNumber ? action.payload : permitInfo)),
      }
    }
    case actions.DELETE_PERMIT: {
      return {
        ...state,
        permits: state.permits.filter((permitInfo) => permitInfo.plateNumber !== action.payload.plateNumber),
      }
    }
    case actions.CLEAR_INSURANCE_INFO_ACTION: {
      return {
        ...state,
        insuranceCompany: initialState.insuranceCompany,
        policyNumber: initialState.policyNumber,
        effectiveDate: initialState.effectiveDate,
        expiryDate: initialState.expiryDate,
      }
    }
    case actions.CLEAR_PERMIT_INFO: {
      return {
        ...state,
        plateNumber: initialState.plateNumber,
        vinSerialNumber: initialState.vinSerialNumber,
        insuranceCompany: initialState.insuranceCompany,
        policyNumber: initialState.policyNumber,
        effectiveDate: initialState.effectiveDate,
        expiryDate: initialState.expiryDate,
        renewalperiods: initialState.renewalPeriod,
        commercialAquaculture: initialState.commercialAquaculture,
        fishingVessel: initialState.fishingVessel,
        renewalPeriod: initialState.renewalPeriod,
        vehicleType: initialState.vehicleType
      }
    }
    case actions.EDIT_FROM_CONFIRMATION: {
      return {
        ...state,
        editFromConfirmation: action.payload.description,
      }
    }
    case actions.CLEAR_ALL_USER_DATA: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default AppReducer
